export function normalizePathname(pathname = '/') {
  const cleanPath = pathname.split('?')[0].split('#')[0];
  const routeName = cleanPath.split('/').filter(Boolean).pop() || 'index';
  return routeName.toLowerCase().replace(/\.html$/, '');
}

export function escapeHtml(value = '') {
  const entities = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;',
  };

  return String(value).replace(/[&<>"']/g, (character) => entities[character]);
}

export function chooseImageSource(config, support = {}) {
  if (!config || typeof config !== 'object') {
    return '';
  }

  if (support.avif && config.avif) {
    return config.avif;
  }

  if (support.webp && config.webp) {
    return config.webp;
  }

  return config.default || '';
}

export function isValidSearchTerm(value = '') {
  return /^[\p{L}\p{N}\s-]{1,60}$/u.test(String(value).trim());
}
